import { WorkOrderStatusEnum } from 'gql/graphql';

export const useGetChangeStatusDialogText = ({
    currentStatus,
    nextStatus,
    isFrameContract,
}: {
    currentStatus: WorkOrderStatusEnum | undefined;
    nextStatus: WorkOrderStatusEnum;
    isFrameContract: boolean;
}) => {
    const isDefaultStatusOnFormation = currentStatus === WorkOrderStatusEnum.OnFormation;
    const isDefaultStatusInProgress = currentStatus === WorkOrderStatusEnum.InProgress;
    const isDefaultStatusDelayed = currentStatus === WorkOrderStatusEnum.Delayed;
    const isChangedStatusOnFormation = nextStatus === WorkOrderStatusEnum.OnFormation;
    const isChangedStatusDelayed = nextStatus === WorkOrderStatusEnum.Delayed;
    const isChangedStatusCompleted = nextStatus === WorkOrderStatusEnum.Completed;
    const isChangedStatusInProgress = nextStatus === WorkOrderStatusEnum.InProgress;

    const workOrderTypeText = isFrameContract ? 'по Наряд-Заказу' : 'с Расчетом по Договору';

    if (isChangedStatusInProgress) {
        return (
            <>
                {!isDefaultStatusDelayed && (
                    <div style={{ marginBottom: '16px' }}>
                        После перевода в статус «В работе» редактирование структуры в&nbsp;
                        {isFrameContract ? 'Наряд-Заказе' : 'Расчете по договору'} приведет к созданию&nbsp;
                        {isFrameContract
                            ? 'изменения к Наряд-Заказу или Доп.Соглашения.'
                            : 'Дополнительного соглашения.'}
                    </div>
                )}
                <div>Вы уверенны, что хотите изменить статус на «В работе?»</div>
            </>
        );
    }

    if (isChangedStatusOnFormation) {
        return <div>Вы уверены, что хотите изменить статус на «На формировании»?</div>;
    }

    if (isDefaultStatusInProgress && isChangedStatusCompleted) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>
                    После перевода в статус «Завершён» дальнейшая работа {workOrderTypeText} будет недоступна
                </div>
                <div>Вы уверены, что хотите изменить статус на «Завершён?»</div>
            </>
        );
    }

    if (
        (isDefaultStatusOnFormation && isChangedStatusDelayed) ||
        (isDefaultStatusInProgress && isChangedStatusDelayed)
    ) {
        return (
            <>
                <div style={{ marginBottom: '16px' }}>Дальнейшая работа {workOrderTypeText} будет недоступна.</div>
                <div>Вы уверены, что хотите изменить статус на «Отложен?»</div>
            </>
        );
    }

    return null;
};
